export default function initAnimacaoScroll() {
  const sections = document.querySelectorAll("#srollSuave");
  const windowMetade = window.innerHeight * 0.6;

  console.log(sections);

  function animaScroll() {
    sections.forEach((section) => {
      const sectionTop = section.getBoundingClientRect().top;
      const isSectionVisible = sectionTop - windowMetade < 0;
      if (isSectionVisible) {
        section.classList.add("ativo");
        window.removeEventListener("scroll", initAnimacaoScroll);
      } else if (section.classList.contains("ativo")) {
        section.classList.remove("ativo");
      }
    });
  }

  if (sections.length) {
    console.log(sections);

    animaScroll();

    window.addEventListener("scroll", animaScroll);
  }
}
